import { API_STATUSES } from "../../_helpers/statuses";
import { API_CALLS } from "../_commonApiCalls/fleetApi";
import {
    getSsidDataStatus,
    getSsidData,
    setSsidDataStatus,
    setSsidData
} from "../_commonReducers/fleetReducers";

// ======================================================== Headers Configuration Start ================================== //
export const headersConfigData = () => {
    const credentialsData = localStorage.getItem("vkey");
    return {
        "Content-Type": "application/json",
        Authorization: "Basic " + credentialsData,
    };
};

// ======================================================== Headers Configuration End ==================================== //

const getSsidDataService = (siteId) => {
    return async function getSsid(dispatch) {
        dispatch(getSsidDataStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSsidDataApiCall(siteId, headersConfigData);
            let jsonResponse = await response.json();

            dispatch(getSsidData(jsonResponse));
            dispatch(getSsidDataStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getSsidDataStatus(err));
            dispatch(getSsidDataStatus(API_STATUSES.ERROR));
        }
    }
}

const setSSIDDataService = (siteId, request) => {
    return async function saveSsidData(dispatch) {
        dispatch(setSsidDataStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setSSIDDataApiCall(siteId, request, headersConfigData);
            let jsonResponse = await response.json();

            dispatch(setSsidData(jsonResponse));
            dispatch(setSsidDataStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(setSsidDataStatus(err));
            dispatch(setSsidDataStatus(API_STATUSES.ERROR));
        }
    }
}

export const FLEET_SERVICES = {
    getSsidDataService,
    setSSIDDataService
};
